@if (isUserPartiallyLdapActive && otherClusters.length > 0) {
  <div class="alert alert-warning pt-2 text-center">
    <i [ngClass]="ziroIcons.WARNING_TRIANGLE" class="text-warning pe-2"></i>
    <span
      [innerHTML]="'tkey;shared.site.site_picker.new_user.ldap_sync.alert' | escapeHtml: { clusters: getClusters() }"
    ></span>
  </div>
}
<br />
<ziro-select [fieldId]="'sitePickerSelect'"></ziro-select>
